import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

export const StyledSMSIcon = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
  height: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
`;

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const StyledDescription = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgContrast};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  text-align: center;
  max-width: 200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
export const StyledSecondaryButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledResendText = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledAlertContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceLayoutXxl}px;
`;
